export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M20.204 7.01A2 2 0 0 1 22 9v6a2 2 0 0 1-1.796 1.99L20 17H4a2 2 0 0 1-1.99-1.796L2 15V9a2 2 0 0 1 2-2h16l.204.01ZM4 8.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5H4Zm7 5.5H5v-4h6v4Z"/>
</svg>
`;
